import api from './api';
import { toast } from 'react-toastify';

const showToast = (message, type = 0, options = {}) => {
    const defaultOptions = {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
    };

    const toastOptions = { ...defaultOptions, ...options };

    if (type == 0) {
        toast.success(message, toastOptions);
    } else {
        toast.error(message, toastOptions);
    }
};

export const bookPrint = (params, page) => {
    return async (dispatch) => {
        try {
            // Gọi API
            if (params == null) {
                params = {
                    type: 'print_book',
                    page: page,
                };
            }
            const response = await api.get('api/books', params, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            dispatch({ type: 'BOOK_PRINT_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'BOOK_PRINT_FAILURE', payload: error.message });
        }
    };
};

export const bookPdf = (params, page) => {
    return async (dispatch) => {
        try {
            // Gọi API
            if (params == null) {
                params = {
                    type: 'pdf',
                    page: page,
                };
            }
            const response = await api.get('api/books', params, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            dispatch({ type: 'BOOK_PDF_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'BOOK_PDF_FAILURE', payload: error.message });
        }
    };
};

export const mybookPdf = (user) => {
    return async (dispatch) => {
        try {
            const response = await api.get(
                'api/books?with_revenue=true&owner_id=' + user.id + '&book_classify_id=1&type=pdf',
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );
            dispatch({ type: 'MY_BOOK_PDF_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'BOOK_PDF_FAILURE', payload: error.message });
        }
    };
};

export const mybookPrint = (user) => {
    return async (dispatch) => {
        try {
            const response = await api.get(
                'api/books?with_revenue=true&owner_id=' + user.id + '&book_classify_id=1&type=print_book',
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );
            dispatch({ type: 'MY_BOOK_PRINT_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'BOOK_PDF_FAILURE', payload: error.message });
        }
    };
};

export const socialMemory = () => {
    return async (dispatch) => {
        try {
            const response = await api.get(
                'api/by/kyucxahoi?keyword=&with_trashed=true',
                {},
                {
                    'Content-Type': 'application/json',
                    // Authorization: 'Bearer ' + token,
                },
            );
            dispatch({ type: 'SOCIAL_MEMORY', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'SOCIAL_MEMORY', payload: error.message });
        }
    };
};

export const socialMemoryPdf = (token, owner_id) => {
    return async (dispatch) => {
        try {
            // Gọi API
            const params = {
                type: 'pdf',
                with_revenue: true,
                owner_id: owner_id,
            };
            const response = await api.get('api/books', params, {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });
            dispatch({ type: 'SOCIAL_MEMORY_PDF_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'SOCIAL_MEMORY_PDF_FAILURE', payload: error.message });
        }
    };
};

export const socialMemoryPrint = (token, owner_id) => {
    return async (dispatch) => {
        try {
            // Gọi API
            const params = {
                type: 'print',
                with_revenue: true,
                owner_id: owner_id,
            };
            const response = await api.get('api/books', params, {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });
            dispatch({ type: 'SOCIAL_MEMORY_PRINT_SUCCESS', payload: response.data });
            console.log(response);
        } catch (error) {
            dispatch({ type: 'SOCIAL_MEMORY_PRINT_FAILURE', payload: error.message });
        }
    };
};

export const add_book_pdf = (token, formData) => {
    return async (dispatch) => {
        try {
            const response = await api.post('api/books', formData, {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });

            if (response.data.status === 200) {
                showToast('Đã thêm 1 sách pdf mới, chờ admin duyệt');
                return response;
            } else {
                const message = 'Gửi yêu cầu thất bại';

                showToast(message, 1);
                throw new Error(message);
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    };
};

export const add_book_print = (token, formData) => {
    return async (dispatch) => {
        try {
            console.log(token);
            const response = await api.post('api/books', formData, {
                // 'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });

            if (response.data.status === 200) {
                showToast('Đã thêm 1 sách giấy mới, chờ admin duyệt');
                return response;
            } else {
                const message = 'Gửi yêu cầu thất bại';

                showToast(message, 1);
                throw new Error(message);
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    };
};

export const edit_book_print = (token, formData, id) => {
    return async (dispatch) => {
        try {
            console.log(token);
            const response = await api.post('api/books/' + id, formData, {
                // 'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });

            if (response.data.status === 200) {
                showToast('Đã sửa sản phẩm thành công');
                return response;
            } else {
                const message = 'Gửi yêu cầu thất bại';

                showToast(message, 1);
                throw new Error(message);
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    };
};

export const add_chapter = (token, formData, id) => {
    return async (dispatch) => {
        try {
            const response = await api.post('api/books/' + id + '/chapters', formData, {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            });

            if (response.data.status === 200) {
                // showToast('Đã thêm 1 khoá học online');
                return true;
            } else {
                const message = 'Gửi yêu cầu thất bại';

                showToast(message, 1);
                throw new Error(message);
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    };
};
